import type { InsightsLandingPageItemTarget } from "shared/modules/Insights/types";
import type { BulkFavoriteResponse } from "shared/types/favorite";

import ApiClient from "./ApiClient";

class FavoriteService extends ApiClient {
  constructor() {
    super("/favorites");
  }

  archive(target: InsightsLandingPageItemTarget) {
    return this.post<BulkFavoriteResponse>("/archive_favorite_target", {
      data: {
        target,
      },
    });
  }

  bulkAddFavorite(targets: InsightsLandingPageItemTarget[]) {
    return this.post<BulkFavoriteResponse>("/bulk_add_favorite", {
      data: {
        targets,
      },
    });
  }

  bulkArchive(targets: InsightsLandingPageItemTarget[]) {
    return this.post<BulkFavoriteResponse>("/bulk_archive_favorite_targets", {
      data: {
        targets,
      },
    });
  }

  bulkRemoveFavorite(targets: InsightsLandingPageItemTarget[]) {
    return this.post<BulkFavoriteResponse>("/bulk_remove_favorite", {
      data: {
        targets,
      },
    });
  }
}

export default new FavoriteService();
